const nothing = () => {}

let hooks = {
  onConnection: nothing,
  onDisconnection: nothing,
  beforeSend: JSON.stringify,
  shouldSend: () => true,
  onFailure: nothing,
}

export const setHooks = newHooks => {
  hooks = { ...hooks, ...newHooks }
}

export const getHook = name => hooks[name]
